import type { AssistantCard, ViewKind } from '@secretario/shared';

/** Cartões que abrem um painel do palco no lugar de sair da tela. */
export const CARD_VIEW: Partial<Record<AssistantCard['kind'], ViewKind>> = {
  agenda: 'agenda_day',
  day: 'arrival',
};

/**
 * O painel que o toque no cartão abre, se houver. Cartão de uma habilidade da
 * Equipe (`art`) leva à página dela; só o de contas tem painel próprio.
 */
export function panelOfCard(card: AssistantCard): ViewKind | undefined {
  if (card.art) return card.art === 'contas' ? 'bills' : undefined;
  return CARD_VIEW[card.kind];
}
